<template>
    <v-dialog
        v-model="e.show"
        max-width="500"
    >
        <v-card>
            <v-card-title class="headline flex-column pa-2">
                <div class="fill-width">
                    {{e.title}}
                    <v-btn icon @click="e.show = false" class="float-right"><v-icon>mdi-close</v-icon></v-btn>
                </div>
            </v-card-title>

            <v-card-text>
                {{e.text}}
            </v-card-text>

            <v-card-actions>
                <v-btn class="zoezi-button-thin" color="primary" outlined @click="e.show = false">{{$translate('Cancel')}}</v-btn>
                <v-spacer />
                <v-btn
                    class="zoezi-button-thin"
                    :color="e.actionColor || 'primary'"
                    @click="e.show = false; e.action()"
                >
                    {{e.actionText}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'zoezi-confirm-dialog',

    computed: {
        e() {
            return this.$store.state.confirmDialog;
        }
    }
}
</script>
